$(document).ready(function(){
  

if($('.form__message').length>0){
  $("#myModal").show();
  document.body.classList.add("modal-open");
}
if($('.form_success').length>0){
  $("#myModal").show();
  $("#myModal").find('.booking_form').hide();
  $("#myModal").find('.custom_submit_btn').hide();
  document.body.classList.add("modal-open");
  var location = window.location.href.split('?contact_posted')[0];
  history.pushState({}, "", location);
}

  

  jQuery.getJSON('/cart.js', function(cart) {
    $('.Nz_cartCount').text(cart.item_count);
    if(cart.item_count==0)
      {
        $('.Nz_cartCount').hide();
      }else{
        $('.Nz_cartCount').show();
      }
   });

  

  $('#Details-menu-drawer-container .header__icons .icon-hamburger').click(function(){
      $("html").addClass("myClass activeDrawer");
  });
  if ($(window).width() < 768) {
    $('body').on('click','.footer__block__nz',function(){
        $(this).toggleClass('active');
        $(this).parent('.footer-block').find('.footer-block__details-content').slideToggle("slow");
    });
  }
  $('#menu-drawer .close_draw .icon-close').click(function(){
      $("html").removeClass("myClass activeDrawer");
      $('summary.header__icon').trigger('click');
  });

  

  $('.nzCart_cartDrawer').click(function(event){
      event.preventDefault();
      $('body').toggleClass('overflow-hidden');
      $('cart-drawer').toggleClass('active');
  });

  

  $('.custom-icons .chat, .Lik_icons_out .chat, .custom-icons-drawer .chat, .nz_chat_us').click(function(e) {
    e.preventDefault(); // Evita cualquier comportamiento por defecto del enlace
    
    // Obtiene el atributo data-reamaze-article si existe
    var articleUrl = $(this).attr('data-reamaze-article');
    var prefilledMessage = $(this).attr('data-reamaze-message'); // Opcional, para compatibilidad con tu requerimiento anterior
    
    if (window.Reamaze && typeof Reamaze === 'function') {
      if (articleUrl) {
        // Intenta abrir el artículo en el widget
        Reamaze('open', { article: articleUrl });
      } else if (prefilledMessage) {
        // Envía un mensaje prellenado (para tu requerimiento anterior)
        Reamaze('message', { body: prefilledMessage });
        Reamaze('open');
      } else {
        // Comportamiento por defecto: abre el chat
        $('#reamaze-widget').trigger('click');
      }
    } else {
      console.log('Reamaze no está disponible');
      // Opcional: fallback al comportamiento por defecto
      $('#reamaze-widget').trigger('click');
    }
  });

  // Mantén tu setTimeout para agregar la clase
  window.setTimeout(function() {
    $('.chatway-launcher').addClass("test");
  }, 2000);

  

  if(window.location.href.indexOf('collections')>-1){
    var data =window.location.href.split('=')[1];
    if(data!=undefined){
       if(data.indexOf('&')){
        data = data.split('&')[0];
      }
       $('.select_price_range .select__price__range .select_price_range_option').prop('checked',false);
       $('.select_price_range .select__price__range .select_price_range_option[data-value="'+data+'"]').prop('checked',true);
    }
    $('.select_price_range .select__price__range .select_price_range_option,.select_price_range .select__price__range .select_price_range_label').click(function(){
      var data_value = $(this).attr('data-value');
      $('.select_price_range .select__select option').removeAttr('selected');
      $('.select_price_range .select__select option[value="'+data_value+'"]').attr('selected','selected');
      $('.select_price_range .select__select option[value="'+data_value+'"]').trigger('click');
      var data_url =window.location.href
      if(data_url.indexOf('?sort_by=')>-1){
        data_url = data_url.split('?')[0];
        var data =data_url+'?sort_by='+data_value;
        setTimeout(function(){window.location.href=data},100);
      }else{
        data_url =window.location.href+'?sort_by='+data_value;
        setTimeout(function(){window.location.href=data_url},100);
      }
    });
  }



  if(window.location.href.indexOf('collections')>-1){
     $('.product-card-wrapper .Nzmedia').mouseenter(function(){
        var data_id = $(this).find('.media--hover-effect').attr('data-id');
        $(this).find('.card_product_variant').hide();
        $(this).find('.card_product_variant[data-id="'+data_id+'"]').show();
      });
      $('.product-card-wrapper .Nzmedia').mouseleave(function(){
         $(this).find('.card_product_variant').hide();
      });
    }



   if(window.location.href.indexOf('design-your-dress')>-1){
     $('.c-mod-out .cancel_button').click(function(){
       $(this).closest('.c-mod-out').find('.close_modal').trigger('click');
     });
     
     $('#FABRIC .gallery_modal_wrapper .modal_wrap .plus_click').click(function(){
       var data = $(this).closest('.modal_wrap').attr('data-target');
       
       if($(this).closest('.modal_wrap').hasClass('tulle_fabric')){
          $('.modal-outer-wrapper .image_popup').removeClass('active');
          $('.modal_container .option_list[data-target="'+data+'"]').addClass('active');
          // $('.modal-outer-wrapper .option_list[data-target="'+data+'"]').show();
       }else{
         $('.modal-outer-wrapper .image_popup').removeClass('active');
         $('.modal-outer-wrapper .image_popup[data-target="'+data+'"]').addClass('active');
       }
       $('body').addClass('popup_open');
     });
     
     $('.modal_container .tulle_fabric_list .tulle_fabric_option').click(function(){
       var data = $(this).attr('data-target');
       $('.modal_container .tulle_fabric_list .tulle_fabric_option').not($(this)).removeClass('active');
       $(this).addClass('active');
       $('.modal_container .tulle_fabric .option_list').removeClass('active');
       $('.modal-outer-wrapper .image_popup').removeClass('active');
       $('.modal-outer-wrapper .image_popup[data-target="'+data+'"]').addClass('active');
       $('body').addClass('popup_open');
     });
     $('.image_popup .popup_image .icon_close').click(function(){
       $(this).closest('.image_popup').removeClass('active');
       $('body').removeClass('popup_open');
     });
     $(document).mouseup(function(e){
        var container = $(".popup_image , .tulle_fabric_list");
        if (!container.is(e.target) && container.has(e.target).length === 0) 
        {
          $('.image_popup, .option_list').removeClass('active');
          $('body').removeClass('popup_open');
        }
     });
   }

  
});